import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import {
  Chip,
  Box,
  Stack,
  TableSortLabel,
  Tooltip,
  Typography,
} from "@mui/material";
import { formatNumber, formatPercent } from "../../../../../utils/helpers";
import { ReceiptStatus } from "../ReceiptsTable/ReceiptStatus";

interface Props {
  tableHeadings: { [key: string]: string };
  deleteRow: any;
}

const DeleteReceiptTable = ({ tableHeadings, deleteRow }: Props) => {
  const headCells = Object.entries(tableHeadings);

  const renderFME = (row: any) => {
    const fmeIds = row?.fmes
      ?.map((fme: any) => fme?.fme_id)
      .filter((i: any) => i !== null && i !== undefined);
    const hasData = fmeIds && fmeIds.length > 0;
    const label = hasData
      ? fmeIds
          .slice(0, 3)
          .map((id: any) => `${id}`)
          .join(", ") + (fmeIds.length > 3 ? "..." : "")
      : "N/A";

    const chip = (
      <Chip
        label={label}
        disabled={!hasData}
        sx={{
          backgroundColor: "#ffffff",
          color: "rgba(0, 0, 0, 0.87)",
          borderRadius: "5px",
          boxShadow: "1px 1px 2px 1px #00000030",
          height: "26px",
          fontWeight: "500",
          cursor: "pointer",
          border: "1px solid #ffffff",
          "&:hover": {
            backgroundColor: "transparent",
            color: "#9c27b0", // slightly darker on hover
            border: "1px solid #9c27b0",
          },
        }}
      />
    );

    if (!hasData) return chip;

    return (
      <Tooltip
        title={
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            {fmeIds?.map((id: any, index: number) => (
              <Typography key={index} variant="caption">
                {id}
              </Typography>
            ))}
          </Box>
        }
        arrow
        placement="top"
      >
        {chip}
      </Tooltip>
    );
  };

  const getDebitValue = (row: any) => {
    return (
      row?.total_manual || row?.total_policy || row?.total_fmes_income || 0
    );
  };

  return (
    <>
      <TableContainer className="receiptsTable " sx={{ my: 3 }}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              {headCells.map(([_, value], index) => (
                <TableCell key={index} align="left">
                  <TableSortLabel>
                    {value && typeof value === "string" ? value : ""}
                  </TableSortLabel>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {(Array.isArray(deleteRow)
              ? deleteRow
              : deleteRow
              ? [deleteRow]
              : []
            ).map((row: any) => (
              <React.Fragment key={row.cron_id}>
                <TableRow
                  sx={{
                    "& > *": {
                      borderBottom:
                        "1px solid rgba(224, 224, 224, 1) !important",
                    },
                  }}
                >
                  <TableCell align="left">
                    {row?.finance_company_name}
                  </TableCell>
                  <TableCell align="left">{row?.receipt_id}</TableCell>
                  <TableCell align="left">
                    <Box display={"flex"} alignItems={"center"}>
                      {formatNumber(row?.receipt_amount || "")}
                      <Stack
                        sx={{
                          color: "rgba(0, 0, 0, 0.56)",
                          fontSize: "18px !important",
                          fontWeight: "400",
                          ml: 0.5,
                        }}
                      >
                        {row?.receipt_currency_symbol || ""}
                      </Stack>
                    </Box>
                  </TableCell>
                  <TableCell align="left">{renderFME(row)}</TableCell>
                  <TableCell align="left">
                    <Box display={"flex"} alignItems={"center"}>
                      {getDebitValue(row)}
                      <Stack
                        sx={{
                          color: "rgba(0, 0, 0, 0.56)",
                          fontSize: "18px !important",
                          fontWeight: "400",
                          ml: 0.5,
                        }}
                      >
                        {row?.receipt_currency_symbol || ""}
                      </Stack>
                    </Box>
                  </TableCell>
                  <TableCell align="left">
                    {row?.total_covered
                      ? formatPercent(row?.total_covered)
                      : ""}
                  </TableCell>
                  <TableCell align="left">
                    <ReceiptStatus status={row?.receipt_status} />
                  </TableCell>
                </TableRow>
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default DeleteReceiptTable;
